import { Add } from '@mui/icons-material';
import { Button, CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import {
  ConditionOperation,
  ConditionType,
  ReferenceType,
} from 'api/models/FieldTemplate';
import { useTranslation } from 'react-i18next';
import { useSetRecoilState } from 'recoil';
import { filterState } from 'state/exportState';

interface AddFilterContainerProps {
  loading: boolean;
}

export default function AddFilterContainer({
  loading,
}: AddFilterContainerProps) {
  const { t } = useTranslation();
  const setFilters = useSetRecoilState(filterState);

  const onAddFilter = (type: ReferenceType) => {
    switch (type) {
      case ReferenceType.patientFieldReference:
        return setFilters(filters => [
          ...filters,
          {
            type: ConditionType.condition,
            reference: {
              type: ReferenceType.patientFieldReference,
              attribute: '',
            },
            operation: ConditionOperation.EQUALS,
            value: '',
          },
        ]);
      case ReferenceType.formFieldReference:
        return setFilters(filters => [
          ...filters,
          {
            type: ConditionType.condition,
            reference: {
              type: ReferenceType.formFieldReference,
              attribute: '',
            },
            operation: ConditionOperation.EQUALS,
            value: '',
          },
        ]);

      case ReferenceType.formReference:
        return setFilters(filters => [
          ...filters,
          {
            type: ConditionType.condition,
            reference: {
              type: ReferenceType.formReference,
              attribute: '',
            },
            operation: ConditionOperation.IS_ANY_OF,
            value: [],
          },
        ]);
    }
  };

  return (
    <Box position={'relative'}>
      {loading && (
        <Box
          width="100%"
          height={'100%'}
          top={0}
          left={0}
          position={'absolute'}
          display="flex"
          justifyContent={'center'}
          alignItems={'center'}
        >
          <CircularProgress />
        </Box>
      )}
      <Typography variant="h6" mb={2}>
        {t('export.addFilterCriteria')}
      </Typography>
      <Box>
        <Button
          variant="contained"
          startIcon={<Add />}
          sx={{ mr: 1 }}
          onClick={() => onAddFilter(ReferenceType.patientFieldReference)}
          disabled={loading}
        >
          {t('export.addFilter.patient')}
        </Button>
        <Button
          variant="contained"
          startIcon={<Add />}
          sx={{ mr: 1 }}
          onClick={() => onAddFilter(ReferenceType.formFieldReference)}
          disabled={loading}
        >
          {t('export.addFilter.fieldTemplate')}
        </Button>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => onAddFilter(ReferenceType.formReference)}
          disabled={loading}
        >
          {t('export.addFilter.formTemplate')}
        </Button>
      </Box>
    </Box>
  );
}
